import api from 'api';

export const getSignals = (params) => {
  return api.get('/signals', params, 'bearer');
};

export const getSignal = (id, params) => {
  return api.get(`/signals/${id}`, params, 'bearer');
};

export const updateSignal = (id, body) => {
  return api.put(`/signals/${id}`, body, 'bearer');
};

export const createSignal = (body) => {
  return api.post('/signals', body, 'bearer');
};

export const deleteSignal = (id) => {
  return api.delete(`/signals/${id}`, 'bearer');
};
